//ELECTRICAL
export const GET_ELECTRICAL = 'GET_ELECTRICAL';
export const ERROR_ELECTRICAL = 'ERROR_ELECTRICAL';
export const GET_ELECTRICAL_MASTER_LIST = 'GET_ELECTRICAL_MASTER_LIST';
export const ERROR_ELECTRICAL_MASTER_LIST = 'ERROR_ELECTRICAL_MASTEER_LIST';

//CLEAR ELECTRICAL
export const CLEAR_ELECTRICAL = 'CLEAR_ELECTRICAL';